import React from "react";
import { Divider, Header, List } from "semantic-ui-react";
import PropTypes from "prop-types";

export const DocumentRejections = (props) => {
  const { divider, rejections, title } = props;

  let activeRejections = rejections.filter((r) => !r.fixed);

  return (
    <div>
      {divider === false ? null : <Divider hidden />}
      <Header
        icon={props.showIcon ? "thumbs down" : null}
        content={title}
        as={props.size ? "h3" : "h4"}
        subheader="Reasons why this document has been rejected"
        color={props.color}
        dividing
      />
      <List size={props.size ? props.size : "small"} bulleted>
        {activeRejections.map((rejection) => (
          <List.Item key={rejection.id}>
            <List.Content>
              <List.Header
                content={
                  rejection.created_at_formatted
                    ? rejection.created_at_formatted
                    : "Date Unavailable"
                }
              />
              <List.Description>{rejection.information}</List.Description>
            </List.Content>
          </List.Item>
        ))}
      </List>
    </div>
  );
};

DocumentRejections.defaultProps = {
  color: "red",
  showIcon: true,
};

DocumentRejections.propTypes = {
  divider: PropTypes.bool,
  rejections: PropTypes.array,
  size: PropTypes.string,
  title: PropTypes.string.isRequired,
};
